import BlockIcon from '@mui/icons-material/Block';
import HomeIcon from '@mui/icons-material/Home';
import { Box, Button, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

interface AccessDeniedProps {
  title?: string;
  message?: string;
}

export const AccessDenied = ({
  title = 'Access Denied',
  message = "You don't have permission to access this workspace. Please contact your administrator if you believe this is a mistake.",
}: AccessDeniedProps) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
        p: 3,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: 480,
          width: '100%',
          textAlign: 'center',
          p: 5,
          borderRadius: 3,
          border: 1,
          borderColor: 'divider',
        }}
      >
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            bgcolor: 'rgba(211, 47, 47, 0.08)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 3,
          }}
        >
          <BlockIcon sx={{ fontSize: 40, color: 'error.main' }} />
        </Box>

        <Typography variant="h5" fontWeight={600} gutterBottom>
          {title}
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          {message}
        </Typography>

        <Button
          variant="contained"
          startIcon={<HomeIcon />}
          onClick={() => navigate('/')}
          size="large"
        >
          Go to Home
        </Button>
      </Paper>
    </Box>
  );
};
